<template>
  <v-card class="rounded-xl" color="primary" flat outlined>
    <v-system-bar color="accent" dark class="white--text pa-4">
      <span class="text-subtitle-1 ml-1">Flytrap</span>
      <v-spacer></v-spacer>
      <span class="mr-1">
        {{ flyTrap.WiFiSSID }}
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span class="ml-1" v-bind="attrs" v-on="on"
              ><v-icon>{{ wifiIcon }}</v-icon></span
            >
          </template>
          <span>Signal: {{ flyTrap.WiFiRSSIpercent }}%</span>
        </v-tooltip>
      </span>
      <span>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on"
              ><v-icon>{{ chargeIcon }}</v-icon></span
            >
          </template>
          <span>Charge: {{ flyTrap.BatVoltagePercent }}%</span>
        </v-tooltip>
      </span>
    </v-system-bar>
    <v-card-text>
      <v-list subheader color="primary" dark>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-watering-can-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Moisture</v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-list-item-title
              >{{ flyTrap.Moisturepercent }}%</v-list-item-title
            >
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["flyTrap"],
  computed: {
    wifiIcon() {
      if (this.flyTrap.WiFiSSID === "Waiting") {
        return "mdi-wifi-strength-outline-off";
      } else if (this.flyTrap.WiFiRSSIpercent >= 90) {
        return "mdi-wifi-strength-4";
      } else if (this.flyTrap.WiFiRSSIpercent >= 75) {
        return "mdi-wifi-strength-3";
      } else if (this.flyTrap.WiFiRSSIpercent >= 50) {
        return "mdi-wifi-strength-2";
      } else if (this.flyTrap.WiFiRSSIpercent >= 10) {
        return "mdi-wifi-strength-1";
      } else {
        return "mdi-wifi-strength-outline";
      }
    },

    chargeIcon() {
      if (Number(this.flyTrap.BatVoltagePercent) >= 95) {
        return "mdi-battery";
      } else if (Number(this.flyTrap.BatVoltagePercent) >= 90) {
        return "mdi-battery-90";
      } else if (Number(this.flyTrap.BatVoltagePercent) >= 80) {
        return "mdi-battery-80";
      } else if (Number(this.flyTrap.BatVoltagePercent) >= 70) {
        return "mdi-battery-70";
      } else if (Number(this.flyTrap.BatVoltagePercent) >= 60) {
        return "mdi-battery-60";
      } else if (Number(this.flyTrap.BatVoltagePercent) >= 50) {
        return "mdi-battery-50";
      } else if (Number(this.flyTrap.BatVoltagePercent) >= 40) {
        return "mdi-battery-40";
      } else if (Number(this.flyTrap.BatVoltagePercent) >= 30) {
        return "mdi-battery-30";
      } else if (Number(this.flyTrap.BatVoltagePercent) >= 20) {
        return "mdi-battery-20";
      } else if (Number(this.flyTrap.BatVoltagePercent) >= 10) {
        return "mdi-battery-10";
      } else {
        return "mdi-battery-outline";
      }
    },
  },
};
</script>
